import { PapiDeviation } from '@wix/da-papi-types';

export enum PostPopupMode {
  JOURNAL = 'journal',
  STATUS = 'status',
}

export type EditorSwitcherSharedState = {
  document?: any;
  selection?: any;
  hasUnsavedChanges?: boolean;
};

/** A visibility setting for a deviation submission. */
export type VisibilitySetting =
  | { type: 'everyone' }
  | { type: 'tier'; tiers: PapiDeviation[] };
